import { Accessor, createContext, JSX, useContext } from "solid-js";
import { HomeOnecardRouteData } from "../data/home_onecard_route_data";
import { useHomeOnecard } from "../hooks/useHomeOnecard";

export type HomeOnecardContextValue = {
  routeData: Accessor<HomeOnecardRouteData>;
  onBrandClick: (brandKey: string) => void;
} & ReturnType<typeof useHomeOnecard>;

const HomeOnecardContext = createContext<HomeOnecardContextValue>();

export function useHomeOnecardContext() {
  const context = useContext(HomeOnecardContext);
  if (!context) {
    throw new Error(
      "useHomeOnecardContext must be used within HomeOnecardProvider"
    );
  }
  return context;
}

export function HomeOnecardProvider(props: {
  children: JSX.Element;
  value: HomeOnecardContextValue;
}) {
  return (
    <HomeOnecardContext.Provider value={props.value}>
      {props.children}
    </HomeOnecardContext.Provider>
  );
}
